import { resolveSmartAllotmentApiUrl } from "./utils/resolveSmartAllotmentApiUrl";

const S3_BASE_PATH = process.env.REACT_APP_S3_BASE_PATH || "scribeinai_allotments";
const RECYCLE_BIN_PATH = `${S3_BASE_PATH}/recycle-bin`;

// Sync endpoint path relative to apiUrl. If backend returns "Route not found", set REACT_APP_SYNC_DOCTOR_FILES_PATH to your backend route (e.g. "Allotment/SyncDoctorFiles").
const SYNC_DOCTOR_FILES_PATH = process.env.REACT_APP_SYNC_DOCTOR_FILES_PATH || "syncDoctorFiles";

// Base URL for static assets (public folder). Required for Amplify/subpath deploys.
const PUBLIC_URL = process.env.PUBLIC_URL || "";
const asset = (path) => `${PUBLIC_URL.replace(/\/$/, "")}/${(path || "").replace(/^\//, "")}`;

// Dedicated provider UI (Amplify custom domain). Override in env if different from production default.
const DOCTOR_PORTAL_ORIGIN = (process.env.REACT_APP_DOCTOR_PORTAL_ORIGIN || "https://doctor.scribeinai.com").replace(
  /\/+$/,
  ""
);

// Dedicated admin UI (custom domain). Override in env if different from production default.
const ADMIN_PORTAL_ORIGIN = (process.env.REACT_APP_ADMIN_PORTAL_ORIGIN || "https://admin.scribeinai.com").replace(
  /\/+$/,
  ""
);

// Dedicated QA UI host (trans.*). Override in env for white-label / alternate domains.
const QA_PORTAL_ORIGIN = (process.env.REACT_APP_QA_PORTAL_ORIGIN || "https://trans.scribeinai.com").replace(
  /\/+$/,
  ""
);

const MAIN_ADMIN_PORTAL_ORIGIN = (
  process.env.REACT_APP_MAIN_ADMIN_PORTAL_ORIGIN || "https://main.scribeinai.com"
).replace(/\/+$/, "");

// Doctor self-service registration: set REACT_APP_DOCTOR_REGISTER_ENABLED=false until POST /doctor/register exists.
const rawRegisterFlag = (process.env.REACT_APP_DOCTOR_REGISTER_ENABLED ?? "true").toString().trim().toLowerCase();
const doctorRegisterEnabled = rawRegisterFlag !== "false" && rawRegisterFlag !== "0" && rawRegisterFlag !== "no";

const Config = {
  // Development: Leave REACT_APP_API_URL empty to use /api/SmartAllotment (proxied via setupProxy.js)
  // Multi-tenant: same-origin `/api`, REACT_APP_API_URL per deploy, or REACT_APP_API_ORIGIN_TEMPLATE — see .env.example
  apiUrl: resolveSmartAllotmentApiUrl(),
  syncDoctorFilesPath: SYNC_DOCTOR_FILES_PATH,
  S3_BASE_PATH,
  RECYCLE_BIN_PATH,
  asset,
  /** Base URL for doctor subdomain SPA (no trailing slash). */
  doctorPortalOrigin: DOCTOR_PORTAL_ORIGIN,
  /** Sign-in page on doctor host (used when redirecting providers off the main login). */
  doctorPortalLoginUrl: `${DOCTOR_PORTAL_ORIGIN}/login`,
  /** Base URL for admin subdomain SPA (no trailing slash). */
  adminPortalOrigin: ADMIN_PORTAL_ORIGIN,
  /** Sign-in page on admin host. */
  adminPortalLoginUrl: `${ADMIN_PORTAL_ORIGIN}/login`,
  /** Base URL for QA/transcriptionist SPA (no trailing slash). */
  qaPortalOrigin: QA_PORTAL_ORIGIN,
  /** Sign-in page on QA host. */
  qaPortalLoginUrl: `${QA_PORTAL_ORIGIN}/login`,
  /** Main Admin portal (companies / tenants). */
  mainAdminPortalOrigin: MAIN_ADMIN_PORTAL_ORIGIN,
  mainAdminPortalLoginUrl: `${MAIN_ADMIN_PORTAL_ORIGIN}/login`,
  /**
   * When false, `/register` shows an inline message only (no submit, no API call).
   * Env: REACT_APP_DOCTOR_REGISTER_ENABLED=false|0|no (default: true).
   */
  doctorRegisterEnabled,
};

export default Config;
